import { render, staticRenderFns } from "./siteRole.vue?vue&type=template&id=dae9694e&scoped=true&"
import script from "./siteRole.vue?vue&type=script&lang=js&"
export * from "./siteRole.vue?vue&type=script&lang=js&"
import style0 from "./siteRole.vue?vue&type=style&index=0&id=dae9694e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae9694e",
  null
  
)

export default component.exports